// @ts-nocheck
import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Header } from "../components/Header";
import Home from "../pages/Home";
import Menu from "../pages/Menu";
import TermsOfService from "../pages/TermsOfService";
import PrivacyPolicy from "../pages/PrivacyPolicy";

const Navigation = () => (
    <BrowserRouter>
        <Header />
        <div className="main-content">
            <Routes>
                <Route path="*" element={<Navigate to="/home" replace />} />
                <Route path="/home" element={<Home />} />
                <Route path="/home/:businessid" element={<Home />} />
                <Route path="/menu" element={<Menu />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
            </Routes>
        </div>
    </BrowserRouter>
);

export default Navigation;
